import { useEffect, useRef } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"

const POLL_INTERVAL_MS = 2000
const TERMINAL_STATUSES = new Set(["completed", "failed"])

export function useUploadedLeadImportJobPolling(onComplete) {
  const axios = useAuthorizedAxiosClient()
  const pollingRef = useRef(null)
  const onCompleteRef = useRef(onComplete)

  useEffect(() => {
    onCompleteRef.current = onComplete
  }, [onComplete])

  useEffect(() => {
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current)
      }
    }
  }, [])

  function startPolling(jobId) {
    if (!jobId) {
      return
    }

    if (pollingRef.current) {
      clearInterval(pollingRef.current)
    }

    const poll = () => {
      axios
        .get(`/crm/api/uploaded-leads/import-jobs/${jobId}/`)
        .then(({ data }) => {
          if (TERMINAL_STATUSES.has(data.status)) {
            clearInterval(pollingRef.current)
            pollingRef.current = null
            onCompleteRef.current?.(data)
          }
        })
        .catch(() => {
          clearInterval(pollingRef.current)
          pollingRef.current = null
        })
    }

    poll()
    pollingRef.current = setInterval(poll, POLL_INTERVAL_MS)
  }

  return { startPolling }
}
